// extracted by mini-css-extract-plugin
export var alt = "ParagraphLayout-module--alt--7a163";
export var container = "ParagraphLayout-module--container--94cb0";
export var desktopOnly = "ParagraphLayout-module--desktopOnly--fd0bd";
export var main = "ParagraphLayout-module--main--f768e";
export var mobileOnly = "ParagraphLayout-module--mobileOnly--f1be9";
export var paragraphContainer = "ParagraphLayout-module--paragraphContainer--bebed";
export var paragraphContainerAlt = "ParagraphLayout-module--paragraphContainerAlt--1a01a";
export var textLeft = "ParagraphLayout-module--textLeft--ea47a";
export var visuallyHidden = "ParagraphLayout-module--visuallyHidden--ddd4a";